import { render } from "./form_index6.vue?vue&type=template&id=0aac8701&scoped=true"
import script from "./form_index6.vue?vue&type=script&lang=js"
export * from "./form_index6.vue?vue&type=script&lang=js"

import "./form_index6.vue?vue&type=style&index=0&id=0aac8701&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aac8701"]])

export default __exports__